import React from "react";
import "../../css/hosted-video-embed.css";

function getLinkDisplay(url) {
  try {
    const parsed = new URL(url.trim());
    const domain = parsed.hostname.replace(/^www\./i, "");
    const pathPart =
      parsed.pathname === "/" ? "" : parsed.pathname.replace(/\/$/, "");
    const title = `${domain}${pathPart}${parsed.search || ""}`;
    return {
      domain,
      title: title.length > 80 ? `${title.slice(0, 77)}…` : title,
      description: "Tap to open this link in a new tab",
    };
  } catch {
    return {
      domain: "link",
      title: url,
      description: "Tap to open this link in a new tab",
    };
  }
}

export default function ChatLinkCard({ url }) {
  const trimmed = (url || "").trim();
  if (!trimmed) return null;

  const { domain, title, description } = getLinkDisplay(trimmed);
  const favicon = `https://www.google.com/s2/favicons?domain=${encodeURIComponent(domain)}&sz=128`;

  return (
    <div className="hosted-video-embed-block hosted-video-embed-block--card">
      <a
        href={trimmed}
        target="_blank"
        rel="noopener noreferrer"
        className="hosted-video-embed__external-card"
      >
        <div className="hosted-video-embed__card-content">
          <div className="hosted-video-embed__card-title">{title}</div>
          <div className="hosted-video-embed__card-description">
            {description}
          </div>
          <div className="hosted-video-embed__card-footer">
            <img
              src={favicon}
              alt={domain}
              className="hosted-video-embed__card-icon"
            />
            <span className="hosted-video-embed__card-domain">{domain}</span>
          </div>
        </div>
        <div className="hosted-video-embed__card-arrow">{"↗"}</div>
      </a>
    </div>
  );
}
